import TopBar from '@/components/navbar/TopBar';
import axios from 'axios';
import { useEffect, useState, useRef } from 'react';
import toast from 'react-hot-toast';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { SET_PLAYING, SET_PLAYINGFROM, SET_PLAYLOADING, SET_SONG, SET_RELATEDSONGS, SET_DETAIL_PAGE_SONG, SET_LAUNCHTOKENSONG, SET_WALLETBTN } from '@/redux/features/music/musicSlice';
import { SET_DIALOG_OPEN_TWO, SET_SONG_TO_ADD_TWO } from '@/redux/features/music/playlistSlice';
import { RESET_SONG_DRAWER, SET_SONG_DRAWER_OPEN, SET_SONG_DRAWER_SONG } from '@/redux/features/music/songDrawerSlice';
import { Oval, Rings } from 'react-loader-spinner';
import BottomBar from '@/components/sidebar/BottomBar';
import frogImg from "../../assets/greenbird.png"
import { SongCardSkeleton } from '@/components/createSong/CreateSongLoading';
import { SET_OTPCARD, SET_SHOW_LOGIN } from '@/redux/features/auth/authSlice';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { analytics } from '@/firebase';
import { logEvent } from 'firebase/analytics';
import SongCard from '@/components/songCard/LazyLoadSongCard';
import { Play } from 'lucide-react';
import { SpotifyIcon } from '@/components/navbar/SocialIcons';
import SongDetailSkeleton from './SongDetailSkeleton';
import { PLAY_LIVESONG, SET_CREATEDESC, SET_CREATEGENRE, SET_CUSTOMDESC, SET_CUSTOMLYRICS, SET_CUSTOMTITLE, SET_SELECTEDTAB, STOP_LIVESONG } from '@/redux/features/music/createSlice';
import { TradingViewC } from './TradingView';
import ani3 from "../../assets/createani3.gif";
import SongNotFound from './SongNotFound';
import SongActionButton from './SongActionButton';
import SongInfo from './SongInfo';
import LyricsSection from './LyricsSection';

const SongDetail = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { slug } = useParams();
    const { song: activeSong, playing, playLoading, detailsPageSong: song } = useSelector(state => state.music);
    const { user } = useSelector(state => state.auth)
    const [loading, setLoading] = useState(true);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [relatedSongs, setRelatedSongs] = useState([])
    const [showAllTags, setShowAllTags] = useState(false);
    const { currentTime } = useSelector(state => state.music)
    const location = useLocation();
    const [likedLoading, setLikedLoading] = useState(false);
    const [liked, setLiked] = useState(false);
    // const navigate = useNavigate();
    const [loadingRelatedSongs, setLoadingRelatedSongs] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const { liveSong } = useSelector(state => state.create)
    const pollIntervalsRef = useRef({});
    const songStatusRef = useRef({});
    const [isValidUrl, setIsValidUrl] = useState(false);

    // set playing from
    useEffect(() => {
        const { playingFrom } = location.state || {};
        if (playingFrom === 'relatedSongs') {
            dispatch(SET_PLAYINGFROM('relatedSongs'));
        }
        window.scrollTo(0, 0)
    }, [location.state, dispatch]);

    //OTP Card
    useEffect(() => {
        const otpToken = sessionStorage.getItem('otpToken')
        if (otpToken) {
            dispatch(SET_SHOW_LOGIN(true));
            dispatch(SET_OTPCARD(true));
        }
    }, [dispatch])

    // get song details
    useEffect(() => {
        async function getSong() {
            const token = localStorage.getItem('token')
            try {
                setLoading(true);
                setNotFound(false);
                const { data } = await axios.get(`/getsongbyslug?slug=${slug}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setLiked(data?.is_liked)
                dispatch(SET_DETAIL_PAGE_SONG(data));
            } catch (error) {
                console.log(error);
                if (error.response?.data?.detail === "Song not found") {
                    setNotFound(true);
                } else {
                    toast.error("Error getting song details");
                }
            } finally {
                setLoading(false);
            }
        }
        getSong();
        window.scrollTo(0, 0)
    }, [slug, dispatch]);

    // set song details
    useEffect(() => {
        if (activeSong?.song_id === song?.song_id) {
            dispatch(SET_DETAIL_PAGE_SONG(activeSong));
        }
    }, [activeSong, song?.song_id, dispatch]);

    // get related songs
    useEffect(() => {
        async function getRelatedSongs() {
            if (slug) {
                const token = window.localStorage.getItem('token');
                try {
                    setLoadingRelatedSongs(true);
                    const { data } = await axios.get(
                        `/related-songs?genres=${song?.tags}&page=1&limit=20`,
                        { headers: { Authorization: `Bearer ${token}` } }
                    );
                    // Filter out songs without a transcript or with an empty transcript array
                    const filteredSongs = data.songs.filter(
                        (song) => song.transcript && song.transcript.length > 0
                    );
                    setRelatedSongs(filteredSongs);
                    dispatch(SET_RELATEDSONGS(filteredSongs));
                } catch (error) {
                    // Handle error
                } finally {
                    setLoadingRelatedSongs(false);
                }
            }
        }
        getRelatedSongs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [slug, dispatch]);


    // update like status
    useEffect(() => {
        setLiked(song?.is_liked)
    }, [song])

    const handlePause = () => {
        dispatch(SET_PLAYING(false))
    }

    function download(url) {
        const a = document.createElement('a');
        a.href = url;
        a.download = `Sound of Meme`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
    const downloadSong = async () => {
        if (user?.is_guest) {
            toast.error('Login to download the song')
            dispatch(SET_SHOW_LOGIN(true));
            return;
        }
        setDownloadLoading(true)
        const token = window.localStorage.getItem('token')
        try {
            dispatch(SET_SHOW_LOGIN(false));
            toast.loading("Starting Download", { id: "download" })
            const response = await axios.get(`/download?song_id=${song?.song_id}`, { headers: { Authorization: `Bearer ${token}` } });
            const signedUrl = response.data.url;
            download(signedUrl);
            // dispatch(RESET_SONG_DRAWER());
            toast.success("Download Started", { id: "download" })
        } catch (error) {
            console.error('Error fetching signed URL:', error);
            toast.error('Error Occurred. Please try again.', { id: "download" });
        } finally {
            setDownloadLoading(false)
        }
    };

    // add to playlist
    const AddToPlaylist = (e) => {
        if (user?.is_guest) {
            return toast.error('Login to add to playlist')
        }
        e.stopPropagation()
        dispatch(SET_SONG_TO_ADD_TWO(song))
        dispatch(SET_SONG_DRAWER_SONG(song))
        dispatch(SET_DIALOG_OPEN_TWO(true))
        dispatch(SET_SONG_DRAWER_OPEN(false))
        dispatch(RESET_SONG_DRAWER())
    }

    const copyToClipboard = (url) => {
        navigator.clipboard.writeText(url).then(() => {
            toast.success('URL copied to clipboard!', { id: "copyToast" })
        }).catch(err => {
            console.error('Failed to copy:', err);
        });
    };

    // share song
    const handleShare = async (song) => {
        const url = `https://soundofmeme.com/song/${song?.slug}`;
        const title = 'Check out this song!';
        if (navigator.share) {
            try {
                await navigator.share({
                    title,
                    url
                });
            } catch (error) {
                console.error('Error sharing:', error);
            }
        } else {
            copyToClipboard(url)
        }
    };

    const handlePlay = (song) => {
        if (!song?.song_url) {
            toast.error("Cannot play this song, please reload.", { id: "song" });
            return;
        }
        dispatch(SET_PLAYING(true));
        if (activeSong?.song_url === song?.song_url) {
            dispatch(SET_PLAYINGFROM('relatedSongs'));
        } else {
            dispatch(SET_PLAYINGFROM('relatedSongs'));
        }
        dispatch(SET_SONG(song));
        if (activeSong?.song_url !== song?.song_url) {
            dispatch(SET_PLAYLOADING(true));
        }
    };

    // like song
    const handleLike = async (songId) => {
        const token = window.localStorage.getItem('token');
        if (!user || !token || user?.is_guest) {
            toast.error("Login to like the song", { id: "likeSong" });
            dispatch(SET_SHOW_LOGIN(true));
            return;
        }
        try {
            dispatch(SET_SHOW_LOGIN(false));
            setLikedLoading(true);
            const isLiking = !liked;
            const endpoint = isLiking ? "/like" : "/dislike";
            const loadingMessage = isLiking ? "Adding to liked songs" : "Removing from liked songs";
            toast.loading(loadingMessage, { id: "likeSong" });
            await axios.post(endpoint,
                { song_id: songId },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setLikedLoading(false);
            setLiked(isLiking);
            // Update song in redux state with new like status
            const updatedSong = {
                ...song,
                is_liked: isLiking,
                likes: song?.likes + (isLiking ? 1 : -1)
            };
            dispatch(SET_DETAIL_PAGE_SONG(updatedSong))
            if (activeSong?.song_id === song?.song_id) {
                dispatch(SET_SONG(updatedSong));
            }
            toast.success(isLiking ? "Like Added" : "Like Removed", { id: "likeSong" });
        } catch (error) {
            console.log(error);
            setLikedLoading(false);
            toast.error(error.response.data.detail || "Error Occurred", { id: "likeSong" });
        }
    };

    // Add this useEffect to update meta tags when song details load
    useEffect(() => {
        if (song) {
            // Update page title
            document.title = `${song.song_name} | Song Sound Of Meme Music | AI Song Maker`;
            // Update meta description
            const metaDescription = document.querySelector('meta[name="description"]');
            if (metaDescription) {
                metaDescription.setAttribute('content', `${song.lyrics?.slice(0, 150)}...`);
            }
            // Update OpenGraph tags
            const ogTitle = document.querySelector('meta[property="og:title"]');
            if (ogTitle) {
                ogTitle.setAttribute('content', `${song.song_name} | Song Sound Of Meme Music | AI Song Maker`);
            }
            const ogDescription = document.querySelector('meta[property="og:description"]');
            if (ogDescription) {
                ogDescription.setAttribute('content', `${song?.lyrics?.slice(0, 150)}...`);
            }
            const ogImage = document.querySelector('meta[property="og:image"]');
            if (ogImage) {
                ogImage.setAttribute('content', song.image_url || '/meta.gif');
            }
            const ogUrl = document.querySelector('meta[property="og:url"]');
            if (ogUrl) {
                ogUrl.setAttribute('content', `https://soundofmeme.com/song/${song.slug}`);
            }
            // Update Twitter Card tags
            const twitterTitle = document.querySelector('meta[name="twitter:title"]');
            if (twitterTitle) {
                twitterTitle.setAttribute('content', `${song.song_name} | Song Sound Of Meme Music | AI Song Maker`);
            }
            const twitterDescription = document.querySelector('meta[name="twitter:description"]');
            if (twitterDescription) {
                twitterDescription.setAttribute('content', `${song?.lyrics?.slice(0, 150)}...`);
            }
            const twitterImage = document.querySelector('meta[name="twitter:image"]');
            if (twitterImage) {
                twitterImage.setAttribute('content', song.image_url || '/meta.gif');
            }
            // Add or update canonical link
            let canonicalLink = document.querySelector('link[rel="canonical"]');
            if (!canonicalLink) {
                canonicalLink = document.createElement('link');
                canonicalLink.setAttribute('rel', 'canonical');
                document.head.appendChild(canonicalLink);
            }
            canonicalLink.setAttribute('href', `https://soundofmeme.com/song/${song.slug}`);
        }
        // Cleanup function to reset meta tags when component unmounts
        return () => {
            document.title = 'Sound Of Meme | SOME Ai Music Platform | AI Song Maker | Make AI Music';
            // Reset other meta tags to their default values if needed
            // Remove canonical link
            const canonicalLink = document.querySelector('link[rel="canonical"]');
            if (canonicalLink) {
                canonicalLink.remove();
            }
        };
    }, [song]);

    // publish to spotify
    const handlePublishSpotify = async (song) => {
        const token = localStorage.getItem('token');
        if (!user || user?.is_guest) {
            dispatch(SET_SHOW_LOGIN(true))
            return toast.error("Login to publish to Spotify", { id: "publishSpotify" });
        }
        if (user?.plan === 0 || user?.plan === 2 || user?.plan === 1) {
            let planName = '';
            if (user?.plan === 0) {
                planName = 'Free';
            } else if (user?.plan === 1) {
                planName = 'Premium';
            } else if (user?.plan === 2) {
                planName = 'Gold';
            }
            return toast.error(`Please upgrade from ${planName} to Platinum to publish songs on Spotify`, { id: "publishSpotify" });
        }
        try {
            const response = await axios.get(
                'https://engine.soundofmeme.com/song/distribute/',
                {
                    params: { song_id: song?.song_id },
                    headers: { Authorization: `Bearer ${token}` }
                }
            );
            if (response.data.status === 'Uploaded') {
                toast.success("Song Already Published to Spotify", { id: "publishSpotify" });
            } else {
                toast.success(response.data.status, { id: "publishSpotify" });
            }
            // setSong(prev => ({ ...prev, spotify_status: response.data.status, spotify_link: response.data.link }));
        } catch (error) {
            console.log(error);
        }
    };

    // wallet connect
    const handleWalletConnect = () => {
        if (!user || user?.is_guest) {
            dispatch(SET_SHOW_LOGIN(true))
            return toast.error("Login to connect wallet", { id: "walletConnect" })
        }
        dispatch(SET_LAUNCHTOKENSONG(song))
        dispatch(SET_WALLETBTN(true))
    }

    // handle recreate
    const handleRecreate = (song) => {
        if (song?.prompt === null || song.prompt === '' || song.prompt === undefined) {
            toast.error('Feature not available on this song', { id: "recreate" })
            return
        }
        if (song?.prompt?.type === "create" || song?.prompt?.type === "custom") {
            if (song.prompt.type === "create") {
                dispatch(SET_SELECTEDTAB('create'))
                dispatch(SET_CREATEDESC(song.prompt.desc))
                dispatch(SET_CREATEGENRE(song.prompt.genre.split(' ').map(tag => tag.charAt(0).toUpperCase() + tag.slice(1)).join(', ')))
                navigate("/create")
            } else if (song.prompt.type === "custom") {
                dispatch(SET_SELECTEDTAB('custom'))
                dispatch(SET_CUSTOMDESC(song.prompt.genre))
                dispatch(SET_CUSTOMTITLE(song.prompt.title2))
                dispatch(SET_CUSTOMLYRICS(song.prompt.lyrics2))
                navigate("/create")
            }
        } else {
            toast.error('Feature not available on this song', { id: "recreate" })
            return
        }
    }

    // Track Firebase event for traffic from Telegram bot
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const isTelegramSource = searchParams.get('tsrc') === 'tgbot';
        if (isTelegramSource) {
            try {
                logEvent(analytics, 'tg_bot_visit');
            } catch (error) {
                console.log('Firebase event tracking error:', error);
            }
        }
    }, [location.search, song]);

    // check if song_uuid is valid
    useEffect(() => {
        // Function to extract song_uuid from the stream URL
        const checkSongUuid = () => {
            if (!song?.stream) {
                return false;
            }
            try {
                const url = new URL(song.stream);
                const songUuid = url.searchParams.get("song_uuid");
                return songUuid && songUuid.trim() !== "" && songUuid !== "null" && songUuid !== "None";
            } catch (error) {
                console.log("Invalid stream URL:", song.stream);
                return false;
            }
        };
        // Check if song_uuid is valid
        setIsValidUrl(checkSongUuid());
    }, [song?.stream]);

    // toggle play pause live song
    const togglePlayPauseLiveSong = () => {
        if (!isValidUrl) {
            return toast.error('Loading live song...', { id: "playPause" })
        }
        if (liveSong?.isPlaying && liveSong?.streamUrl === song?.stream) {
            dispatch(STOP_LIVESONG());
        } else {
            dispatch(SET_PLAYING(false));
            dispatch(SET_SONG(null))
            // Small delay to ensure previous audio operations are completed
            setTimeout(() => {
                dispatch(PLAY_LIVESONG({
                    streamUrl: song?.stream,
                    isPlaying: true,
                    isBuffering: true  // Start with buffering true
                }));
            }, 100);
        }
    }

    // Modify the startPollingForSongStatus function
    const startPollingForSongStatus = (songId) => {
        const interval = setInterval(async () => {
            try {
                const token = localStorage.getItem('token') || localStorage.getItem("guestToken")
                const { data } = await axios.get(`/songs/?song_ids=${songId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                if (data === null) {
                    toast.error("Unexpected Error, Received null response")
                    clearInterval(interval)
                    delete pollIntervalsRef.current[songId]
                    delete songStatusRef.current[songId];
                } else if (data.status === 'completed') {
                    clearInterval(interval);
                    delete pollIntervalsRef.current[songId];
                    dispatch(SET_DETAIL_PAGE_SONG(data.songs[0]));
                    if (activeSong?.song_id === songId) {
                        dispatch(SET_SONG(data.songs[0]));
                    }
                    dispatch(STOP_LIVESONG());
                    toast.success(`Song is ready to play!`, { id: songId });
                    delete songStatusRef.current[songId];
                } else {
                    // Update song in redux store with latest data
                    if (data.songs && data.songs.length > 0) {
                        dispatch(SET_DETAIL_PAGE_SONG(data.songs[0]));
                        if (activeSong?.song_id === songId) {
                            dispatch(SET_SONG(data.songs[0]));
                        }
                    }
                }
            } catch (error) {
                clearInterval(interval)
                delete pollIntervalsRef.current[songId];
                console.error(error);
                const nextSongIds = error?.response?.data?.next_ids;
                if (nextSongIds) {
                    // Handle retry with new song IDs
                    const songIdsArr = nextSongIds.split(',');
                    if (songIdsArr.length > 0) {
                        startPollingForSongStatus(nextSongIds);
                        songStatusRef.current[songId] = false;
                        songStatusRef.current[nextSongIds] = true;
                        toast("Retrying song generation...", { id: songId });
                    }
                } else {
                    delete songStatusRef.current[songId];
                    toast.error(
                        error?.response?.data?.detail ||
                        error.message ||
                        "Error loading song updates.",
                        { id: songId }
                    );
                }
            }
        }, 10000); // Poll every 10 seconds
        // Store interval ID for cleanup
        pollIntervalsRef.current[songId] = interval;
    };

    // Update the useEffect that triggers polling
    useEffect(() => {
        // Check if song exists and if it needs status updates (e.g., not completed yet)
        if (song && song.song_id && song.status !== "completed") {
            // Only start polling if we aren't already polling for this song
            if (!pollIntervalsRef.current[song.song_id]) {
                songStatusRef.current[song.song_id] = true;
                startPollingForSongStatus(song.song_id);
            }
        }
        // Cleanup function
        return () => {
            // Clear all intervals when component unmounts
            Object.keys(pollIntervalsRef.current).forEach(key => {
                clearInterval(pollIntervalsRef.current[key]);
                // eslint-disable-next-line react-hooks/exhaustive-deps
                delete pollIntervalsRef.current[key];
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [song?.song_id, song?.status]);

    // check if song is not found or error
    if (notFound || song?.status === "error") {
        return (
            <SongNotFound />
        );
    }

    // check if song is loading
    if (loading) {
        return (
            <div className="bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800">
                <TopBar heading="Song Detail" />
                <div className="flex flex-col items-center justify-center min-h-screen">
                    <SongDetailSkeleton />
                </div>
            </div>
        );
    }

    return (
        <div className={`relative min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800 dark:from-pink-200 dark:via-pink-300 dark:to-pink-200 overflow-y-auto ${activeSong?.song_id === song?.song_id || activeSong ? 'sm:pb-20 pb-20' : ''}`}>
            <TopBar heading={song?.song_name} />
            {/* Hero Section */}
            {(song?.status !== "error") && <div className={'relative pt-20 lg:pt-24 mb-1 lg:mb-[7rem]'}>
                <div className='absolute inset-0 bg-cover bg-center blur-3xl opacity-20 dark:opacity-80' style={{ backgroundImage: `url(${song?.image_url})` }} />
                <div className='mx-auto px-4 lg:px-8 relative z-10'>
                    <div className='flex flex-col  lg:flex-row items-start gap-8 lg:gap-8 xl:gap-16'>
                        {/* Left Column - Image and Details */}
                        <div className='w-full lg:h-[250px] lg:min-w-[250px] xl:w-[400px] space-y-8'>
                            {/* Song Image */}
                            <div className='group sm:flex sm:justify-center sm:items-center lg:justify-start lg:items-start'>
                                <div className={'aspect-square sm:w-[400px] rounded-2xl overflow-hidden shadow-2xl relative cursor-pointer bg-white/5 backdrop-blur-sm' + (activeSong?.song_id === song?.song_id && playing ? " border-2 animate-border shadow-lg shadow-cyan-300 dark:shadow-pink-700" : " border border-green-400/60 dark:border-pink-700/60")}>
                                    {/* Spotify Badge */}
                                    {(song?.spotify_status || song?.spotify_link) && (
                                        <div className="absolute top-2 right-2 z-50">
                                            {song?.spotify_link ? (
                                                <a href={song.spotify_link} target="_blank" rel="noopener noreferrer" className="group relative flex items-center justify-center w-8 h-8 rounded-full bg-black/70 hover:bg-green-600/90 transition-all duration-300">
                                                    <SpotifyIcon className="text-green-500 group-hover:text-white text-xl" />
                                                    <span className="absolute invisible group-hover:visible -bottom-8 right-0 bg-black/90 text-white text-xs py-1 px-2 rounded whitespace-nowrap">
                                                        Open in Spotify
                                                    </span>
                                                </a>
                                            ) : (
                                                <div className="group relative z-[9999] flex items-center justify-center">
                                                    <SpotifyIcon className="text-green-400 text-5xl hover:text-green-500 transition-all duration-300" />
                                                    <span className="absolute invisible group-hover:visible top-4 right-1 sm:right-4 bg-black/90 text-white text-xs py-1 px-2 rounded whitespace-wrap !w-36 sm:!w-40">
                                                        {song?.spotify_status || "Processing"}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {/* Status indicator overlay */}
                                    {(song?.status !== "completed" && !song?.image_url) && (
                                        <div className="absolute inset-0 z-40 backdrop-blur-sm flex flex-col items-center justify-center">
                                            <LazyLoadImage src={ani3} alt="Song is being created..." className="w-full h-full" />
                                        </div>
                                    )}
                                    {song?.image_url ? <LazyLoadImage effect="blur" src={song?.image_url} alt={song?.song_name} className={'w-full h-full aspect-square object-cover group-hover:scale-105 transition-all duration-500' + (song?.status !== "completed" ? ' opacity-80' : '')} /> :
                                        <LazyLoadImage effect="blur" src={frogImg} alt={song?.song_name} className={'w-full h-full aspect-square object-cover group-hover:scale-105 transition-all duration-500 p-10' + (song?.status !== "completed" ? ' opacity-80' : '')} />}
                                    <div className={`absolute inset-0 w-full h-full flex items-center justify-center transition-opacity duration-200
                                        ${activeSong?.song_id === song?.song_id && playing ? "opacity-100 bg-black/60 backdrop-blur" : activeSong?.song_id === song?.song_id ? "opacity-100 bg-black/50 backdrop-blur" : "opacity-0 group-hover:opacity-100 bg-black/50"} ${song?.status !== "completed" ? "z-30" : "z-20"}`}>
                                        {(activeSong?.song_id === song?.song_id && playLoading) ? (<div className="w-full h-full flex items-center justify-center cursor-pointer">
                                            <Oval visible={true} height="80" width="80" strokeWidth={6} strokeWidthSecondary={6} color="#ffffff" ariaLabel="oval-loading" />
                                        </div>
                                        ) : (activeSong?.song_id === song?.song_id && playing) ? (
                                            <div onClick={(e) => { e.stopPropagation(); handlePause(song); }} className="w-full h-full flex items-center justify-center cursor-pointer">
                                                <Rings visible={true} height="120" width="120" color="#ffffff" ariaLabel="rings-loading" />
                                            </div>
                                        ) : (
                                            <div onClick={(e) => { e.stopPropagation(); handlePlay(song); }} className="w-full h-full flex items-center justify-center cursor-pointer">
                                                <Play size={60} className="text-white" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* Action Buttons */}
                            <SongActionButton song={song} activeSong={activeSong} playing={playing} handlePause={handlePause} handlePlay={handlePlay} AddToPlaylist={AddToPlaylist} handleWalletConnect={handleWalletConnect} isValidUrl={isValidUrl} togglePlayPauseLiveSong={togglePlayPauseLiveSong} />
                            {/* Song Info */}
                            <SongInfo song={song} user={user} handleLike={handleLike} handlePublishSpotify={handlePublishSpotify} handleRecreate={handleRecreate} handleShare={handleShare} downloadSong={downloadSong} liked={liked} likedLoading={likedLoading} downloadLoading={downloadLoading} showAllTags={showAllTags} setShowAllTags={setShowAllTags} />
                        </div>
                        {/* Right Column - Lyrics */}
                        <LyricsSection song={song} showAllTags={showAllTags} relatedSongs={relatedSongs} currentTime={currentTime} activeSong={activeSong} />
                    </div>
                </div>
            </div>}
            {/* Trading View Chart */}
            {song?.token && (
                <div className='mx-auto flex flex-col justify-start items-start pt-12 rounded-lg  gap-4 dark:bg-pink-200/90 backdrop-blur-md' >
                    <h2 className='text-2xl font-bold text-white dark:text-slate-800 pl-10'>Token Trading Chart</h2>
                    <TradingViewC tokenAddress={song.token.split('/').pop()} />
                </div>
            )}

            {/* Related Songs Section */}
            <div className={"mt-12 mx-auto px-3 sm:px-4 lg:px-8 py-8 " + (playing ? 'pb-12' : '')}>
                <h2 className="text-2xl font-bold text-white dark:text-slate-800 mb-6">Related Songs</h2>
                {loadingRelatedSongs ? (
                    // Related Songs Loading Skeleton
                    <div className="flex-grow py-4 pt-3 w-full grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6 gap-x-4 gap-y-8">
                        {[...Array(12)].map((_, index) => (
                            <div key={index} className="w-full">
                                <SongCardSkeleton />
                            </div>
                        ))}
                    </div>
                ) : relatedSongs && relatedSongs.length > 0 ? (
                    <div className={`flex-grow py-4 pt-3 w-full grid ${song ? "pb-10" : "pb-24"} grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6 gap-x-4 gap-y-8`}>
                        {relatedSongs.map((song, index) => (
                            <div key={index} className="w-full">
                                <SongCard song={song} activeSong={activeSong} playing={playing} playingFrom={'relatedSongs'} />
                            </div>
                        ))}
                    </div>
                ) : null}
            </div>
            <BottomBar />
        </div>
    );
}

export default SongDetail;